export class Helper {
  static setValue(value: any) {
    return value !== undefined ? value : null;
  }

  static setValueArray(value: any) {
    value = this.setValue(value);
    if (value instanceof Array) {
      return value;
    } else {
      return [];
    }
  }

  static getFirstDefinedValue(value1, value2, defaultValue) {
    // this should be replaced with coalescent operator '??' when migrated on TypeScript 3.7
    return value1 != null ? value1 : (value2 != null ? value2 : defaultValue);
  }

  static snake_case_string(str) {
    return str && str.match(
      /[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)
      .map(s => s.toLowerCase())
      .join('_');
  }
}
